(() => {
  document.addEventListener('DOMContentLoaded', () => {

    /* ================================
       Shopify Forms – Shadow DOM Styles
    ================================= */

    const STYLE_ID = 'tmfl-shopify-forms-shadow-style';

    function injectStylesIntoShopifyForms() {
      document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
        const shadow = embed.shadowRoot;
        if (!shadow) return;

        if (shadow.getElementById(STYLE_ID)) return;

        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = `
          button[type="submit"] {
            border-radius: 0px !important;
            text-transform: lowercase !important;
          }
          input {
            border-radius: 0px !important;
          }
        `;
        shadow.appendChild(style);
      });
    }

    injectStylesIntoShopifyForms();

    const formsObserver = new MutationObserver(() => {
      injectStylesIntoShopifyForms();
    });

    formsObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    /* ================================
       Homepage Floating Logo – Desktop
    ================================= */

    // Only run on homepage
    if (!document.body.classList.contains('template-index')) return;

    // Only run on desktop
    if (window.matchMedia('(max-width: 749px)').matches) return;

    const logo = document.querySelector('.homepage-hero-logo');
    if (!logo) return;

    const sections = Array.from(document.querySelectorAll('.shopify-section')).filter(
      (s) =>
        !s.classList.contains('shopify-section-group-header-group') &&
        !s.classList.contains('shopify-section-group-footer-group')
    );

    if (!sections.length) return;

    const stopSection = sections[sections.length - 1];
    let ticking = false;

    const updateLogoPosition = () => {
      ticking = false;

      const logoRect = logo.getBoundingClientRect();
      const desiredY =
        window.innerHeight / 2 - logoRect.height / 2;

      const sectionRect = stopSection.getBoundingClientRect();
      const sectionMidViewport =
        sectionRect.top + sectionRect.height / 2;

      const y = Math.round(
        Math.min(desiredY, sectionMidViewport)
      );

      logo.style.transform =
        `translateX(-50%) translateY(${y}px)`;

      logo.classList.add('is-ready');
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateLogoPosition);
        ticking = true;
      }
    };

    updateLogoPosition();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateLogoPosition);

  });
})();
